import { useState } from 'react'
import { makeStyles } from '@mui/styles'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { logInUserMobile } from '../actions/driverActions'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import FullscreenLoading from '../components/FullscreenLoading'
import {
  getCurrentPayment,
  getSettlementTimeList,
  logInDriverUS
} from '../actions/driverActionsUS'

const useStyles = makeStyles(theme => ({
  loginContainer: {
    width: 285,
    marginTop: 150,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  loginTitle: {
    width: 285,
    color: '#101820',
    fontSize: 24,
    fontWeight: 'bold',
    letterSpacing: 0
  },
  loginDescription: {
    height: 42,
    width: 285,
    color: '#8A8B8A',
    fontSize: 16,
    letterSpacing: 0,
    marginTop: 10
  },
  loginParam: {
    height: 24,
    color: '#101820',
    fontSize: 18,
    letterSpacing: 0
  },
  loginInput: {
    height: 48,
    width: 285
  },
  errorMessage: {
    color: '#E91F1F',
    fontSize: 16,
    letterSpacing: 0
  }
}))

function Login() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [loginFail, setLoginFail] = useState(false)

  async function handleLogin() {
    try {
      setLoading(true)
      const usernameStr = username || document.getElementById('username').value
      const passwordStr = password || document.getElementById('password').value
      if (process.env.REACT_APP_COUNTRY === 'US') {
        const res = await dispatch(logInDriverUS(usernameStr, passwordStr))
        const currentDateRange = await dispatch(
          getSettlementTimeList(res.subjectId)
        )
        await dispatch(
          getCurrentPayment(
            res.subjectId,
            currentDateRange[Object.keys(currentDateRange)[0]].range.start,
            currentDateRange[Object.keys(currentDateRange)[0]].range.end
          )
        )
      } else {
        await dispatch(logInUserMobile(usernameStr, passwordStr))
      }
      await window.localStorage.setItem('income-overview-open', true)
      await history.push('/driverMobile/main')
    } catch (err) {
      setLoginFail(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classes.loginContainer}>
      {process.env.REACT_APP_COUNTRY === 'US' && (
        <div>
          <div className={classes.loginTitle}>Settlement Center</div>
          <div className={classes.loginDescription}>
            Sign in to your driver account to check your settlement history
          </div>
        </div>
      )}
      {process.env.REACT_APP_COUNTRY === 'CA' && (
        <div>
          <div className={classes.loginTitle}>My Income</div>
          <div className={classes.loginDescription}>
            Sign in to your driver account to check your income and payment
            history
          </div>
        </div>
      )}
      <div className={classes.loginParam} style={{ marginTop: 33 }}>
        Mobile number/Username
      </div>
      <TextField
        id='username'
        variant='standard'
        className={classes.loginInput}
        onChange={e => setUsername(e.target.value)}
      />
      {process.env.REACT_APP_COUNTRY === 'US' && (
        <div className={classes.loginParam} style={{ marginTop: 29 }}>
          Password
        </div>
      )}
      {process.env.REACT_APP_COUNTRY === 'CA' && (
        <div className={classes.loginParam} style={{ marginTop: 29 }}>
          SIN
        </div>
      )}
      <TextField
        id='password'
        variant='standard'
        className={classes.loginInput}
        type='password'
        onChange={e => setPassword(e.target.value)}
      />
      <div className={classes.errorMessage} hidden={!loginFail}>
        Invalid login information. Please check details and try again.
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button
          sx={{
            width: 251,
            height: 40,
            color: 'white',
            backgroundColor: '#F68D2E !important',
            borderRadius: '20px',
            marginTop: '107px'
          }}
          onClick={handleLogin}
          disabled={loading}
          fullWidth>
          Sign in
        </Button>
      </div>
      <FullscreenLoading open={loading} />
    </div>
  )
}

export default Login
